export default "__VITE_ASSET__CQR1AhQc__"